<script lang="ts">
  import productContainerDetails from "@shared/filters/product_container_details.js";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import type { CartProduct, Product, ProductLine } from "@shared/types/ProductLine";

  export let rowProduct;
  export let disabled: boolean = false;

  let cartProduct: CartProduct = rowProduct.product;
  let productLine;
  let productDetails;

  if (cartProduct) {
    productLine = cartProduct.product_line;
    productDetails = productContainerDetails()(cartProduct.product, null, null, true);
  } else {
    productLine = rowProduct.product_line_placeholder.product_line;
    productDetails = "Size not selected";
  }
</script>

<tr id="product-{rowProduct.id}" data-id={rowProduct.id} class="productRow">
  <td>
    <div class="drag-handle" class:cursor-grab={!disabled}>
      <Icon width="18" height="18" type="GrabHandle" />
    </div>
    <p>
      <strong>{productLine.name}</strong>
      <br />
      <span class="fizz-text-subdued">{productDetails}</span>
    </p>
  </td>
</tr>
